import axios from 'axios';
import { useState, useCallback } from 'react';

const API_URL = (typeof window !== 'undefined' ? window.__API_URL__ : process.env.REACT_APP_BACKEND_URL) || '';

/**
 * Hook pour gérer l'aperçu email fidèle.
 * Appelle POST /api/email/preview pour obtenir le HTML final avec logo et template.
 */
export function useEmailPreview() {
  const [previewHtml, setPreviewHtml] = useState('');
  const [loadingPreview, setLoadingPreview] = useState(false);

  const fetchPreview = useCallback(async (contenu) => {
    setLoadingPreview(true);
    try {
      const res = await axios.post(`${API_URL}/api/email/preview`, { contenu });
      if (res.status === 200) {
        const data = res.data;
        setPreviewHtml(data.html || '');
      } else {
        // Fallback: rendu simple
        setPreviewHtml((contenu || '').replace(/\n/g, '<br/>'));
      }
    } catch {
      setPreviewHtml((contenu || '').replace(/\n/g, '<br/>'));
    } finally {
      setLoadingPreview(false);
    }
  }, []);

  const clearPreview = useCallback(() => setPreviewHtml(''), []);

  return { previewHtml, loadingPreview, fetchPreview, clearPreview };
}

/**
 * Composant d'aperçu email fidèle dans un iframe.
 * Affiche le HTML exactement comme le client le verra.
 */
export function EmailPreviewFrame({ html, minHeight = 300 }) {
  if (!html) return null;
  return (
    <iframe
      title="Aperçu courriel"
      srcDoc={html}
      className="w-full border rounded-md bg-white"
      style={{ minHeight, height: minHeight }}
      sandbox="allow-same-origin"
      data-testid="email-preview-iframe"
    />
  );
}
